import React from "react";
import { Form } from "../../../components/forms";
import { SUPPORT_EMAIL, SUPPORT_TELEPHONE } from "../../../constants/appProperties";

const InfoPopup = ({ show, onClose }) => {

  if (!show) return null;

  return (
    <Form initialValues={{ message: "" }} enableReinitialize className="d-flex">
      <div className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-50 popup">
        <div className="bg-white rounded p-4 pb-5 shadow-lg info-inner-box">
          <div className="d-flex flex-row align-items-center justify-content-between mx-1 mx-md-4">
            <h5 className="text-primary-600 mb-0 fw-bold">
              Why do we need to know this?
            </h5>
            <button
              onClick={onClose}
              className="d-flex bg-transparent border-0 align-items-center"
            >
              <img
                src="/images/vectors/close-circle.svg"
                alt="close"
                className="google-icon"
              />
            </button>
          </div>
          <hr className="hr-popup mt-4 mb-5" />
          <div className="modal-body mx-1 mx-md-4">
            <div className="container px-0 d-flex flex-column justify-content-between">
              <p className="mb-4 mb-md-7">
                In short, we request your medical records to assess your
                suitability for medical cannabis treatment. With your
                permission, our doctors can access an electronic summary without
                needing to request it specifically from your GP, saving time and
                providing a fuller picture of your medical history ahead of your
                appointment. We will never seek your information without your
                explicit consent.
              </p>
            </div>

            <div className="d-flex flex-column-reverse flex-md-row justify-content-end justify-content-md-between gap-2 gap-md-5 align-items-center px-5 px-md-0 py-4 py-md-0">
              <a
                href="https://wa.me/442477450738"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center justify-content-center gap-2 flow-gap py-2 px-3 w-100 w-md-fit h-fit fw-bold text-decoration-none border rounded bg-transparent text-nowrap
                  text-primary-600 border-primary-600"
              >
                <img
                  src="/images/vectors/whatsapp.svg"
                  alt="completed"
                  className="google-icon"
                />
                Call now
              </a>
              <a
                 href={`tel:${SUPPORT_TELEPHONE}`}
                className="d-flex align-items-center justify-content-center gap-2 flow-gap py-2 px-3 w-100 w-md-fit h-fit fw-bold text-decoration-none border rounded bg-transparent text-nowrap
                  text-primary-600 border-primary-600"
              >
                <img
                  src="/images/vectors/phone-primary.svg"
                  alt="completed"
                  className="google-icon"
                />
                 {SUPPORT_TELEPHONE}
              </a>
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className="d-flex align-items-center justify-content-center gap-2 flow-gap py-2 px-3 w-100 w-md-fit h-fit fw-bold text-decoration-none border rounded bg-transparent text-nowrap
                  text-primary-600 border-primary-600"
              >
                <img
                  src="/images/vectors/mail-primary.svg"
                  alt="completed"
                  className="google-icon"
                />
                {SUPPORT_EMAIL}
              </a>
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default InfoPopup;
